import { getDefaultClient } from '../../factory';
// @endpoint GET /dashboard/:app_id/:dashboard_id
// @controller UserAction.DashboardGet
export async function getDashboard(appId, dashboardId) {
    return getDefaultClient().get(`/dashboard/${appId}/${dashboardId}`);
}
// @endpoint GET /dashboard/:app_id/:dashboard_id/widgets
// @controller UserAction.DashboardWidgets
export async function getDashboardWidgets(appId, dashboardId) {
    return getDefaultClient().get(`/dashboard/${appId}/${dashboardId}/widgets`);
}
// @endpoint GET /export-task/:id
// @controller UserAction.ExportTask
export async function getExportTask(id) {
    return getDefaultClient().get(`/export-task/${id}`);
}
// @endpoint POST /apps/:app_id/widgets-data
// @controller UserAction.FetchWidgetsData
export async function fetchWidgetsData(appId, data) {
    return getDefaultClient().post(`/apps/${appId}/widgets-data`, data);
}
